import React, { useState, useEffect, useContext } from 'react';
import {Form, Input, Select, DatePicker, Checkbox, Row, Space, message, Tag, Tooltip} from 'antd';
import axios from "@common/axios";
import SyllabusTopicConceptSelect from "@common/SyllabusTopicConceptSelect";
import {UserContext} from "@context/UserContext";
import {BrandContext} from "@context/BrandContext";
import ClassSelect from "@common/ClassSelect";
import { Chart } from "react-google-charts";
import TestAssignmentTestResults from "./TestAssignmentTestResults";
import TestAssignmentQuestionResults from "./TestAssignmentQuestionResults";
import TestResult from "../../student/assessments/TestResult";
import TableFilterControls from "@common/TableFilterControls";
import TableAntD from "@common/TableAntD";
import Button from "@common/Button";
import PopConfirm from "@common/PopConfirm";
import CircularLoader from "@common/CircularLoader";
import TestRecipientDialog from "../TestRecipientDialog";
import EditTestAssignmentDialog from "../EditTestAssignmentDialog";
import TableFilterControlsForm from "@common/TableFilterControlsForm";
import TableFilterControlsSection from "@common/TableFilterControlsSection";
import {useFormFilterBadge} from "@hooks/useFormFilterBadge";
import {useScreenReaderAnnouncement} from "@hooks/useScreenReaderAnnouncment";
const { RangePicker } = DatePicker;

const TeacherTestsAssignments = (props) => {
    const {user} = useContext(UserContext),
        brandConfig = useContext(BrandContext),
        [testResultSearchForm] = Form.useForm(),
        [exam, setExam] = useState(false),
        [archived, setArchived] = useState(false),
        classId = Form.useWatch('classId', testResultSearchForm),
        [testGroupCode, setTestGroupCode] = useState(),
        [testAssignerSearchType, setTestAssignerSearchType] = useState('TEACHER'),
        [testType, setTestType] = useState(),
        // [orderBy, setOrderBy] = useState('CREATED_DESC'),
        [testAssignments, setTestAssignments] = useState([]),
        [testAssignmentId, setTestAssignmentId] = useState(),
        [testAssignmentName, setTestAssignmentName] = useState(''),
        [testResult, setTestResult] = useState(),
        [selectedTestAssignments, setSelectedTestAssignments] = useState(() => new Map()),
        [testGroups,setTestGroups] = useState([]),
        [students, setStudents] = useState([]),
        [studentId, setStudentId] = useState(),
        [visibleSection, setVisibleSection] = useState('TEST_ASSIGNMENTS'),
        [isDisableArchive, setDisableArchive] = useState(true),
        [isDisableUnarchive, setDisableUnarchive] = useState(true),
        [isTestGroupsLoading, setTestGroupsLoading] = useState(true),
        [isUpdating, setUpdating] = useState(false),
        [reload, setReload] = useState(),
        [isRecipientDialogOpen, setRecipientDialogOpen] = useState(false),
        [recipientTestAssignmentId, setRecipientTestAssignmentId] = useState(null),
        [recipientClassId, setRecipientClassId] = useState(false),
        [editTestAssignment, setEditTestAssignment] = useState(null),
        {activeFilterCount, onLoadComplete, handleValuesChange: handleBadgeValuesChange} = useFormFilterBadge(testResultSearchForm),
        { setSrAnnouncement, LiveRegion, srAnnouncement } = useScreenReaderAnnouncement(),
        [isEditTestAssignmentDialogOpen, setEditTestAssignmentDialogOpen] = useState(false);

    globalReactFunctions.refreshTeacherTestAssignments = () => {
        setReload(new Date().getTime());
    };

    globalReactFunctions.closeTestAssignmentResults = () => {
        handleCloseTestAssignmentResults();
    };

    globalReactFunctions.closeTestResult = () => {
        handleCloseTestResult();
    };

    const addSelectedTestAssignment = (key, value) => {
        if(!key) {
            return;
        }

        setSelectedTestAssignments(prevMap => {
            const newMap = new Map(prevMap);
            newMap.set(key, value);
            return newMap;
        });
    };

    const addAllSelectedTestAssignments = (testAssignments) => {
        setSelectedTestAssignments(prevMap => {
            const newMap = new Map(prevMap);
            testAssignments.forEach(testAssignment => {
                newMap.set(testAssignment.testAssignmentId, testAssignment);
            });
            return newMap;
        });
    };

    const removeSelectedTestAssignment = (key) => {
        if(!key) {
            return;
        }

        setSelectedTestAssignments(prevMap => {
            const newMap = new Map(prevMap);
            newMap.delete(key);
            return newMap;
        });
    };

    const clearSelectedTestAssignments  = () => {
        setSelectedTestAssignments(new Map());
    };

    useEffect(() => {
        let disableArchive = false;
        let disableUnarchive = false;
        for(const testAssignment of selectedTestAssignments.values()) {
            const owned = testAssignment.assignerUserId === user.userId;
            const ownSchool = testAssignment.schoolId === user.schoolId;

            if(!owned || testAssignment.archived) {
                disableArchive = true;
            }

            if(!owned || !testAssignment.archived) {
                disableUnarchive = true;
            }
        }

        setDisableArchive(disableArchive);
        setDisableUnarchive(disableUnarchive);
    }, [selectedTestAssignments]);

    const onSelectRow = (checked, testAssignment) => {
        if(checked) {
            addSelectedTestAssignment(testAssignment.testAssignmentId, testAssignment);
        } else {
            removeSelectedTestAssignment(testAssignment.testAssignmentId);
        }
    };

    const onSelectAllRows = (checked) => {
        if (checked) {
            addAllSelectedTestAssignments(testAssignments);
        } else {
            clearSelectedTestAssignments();
        }
    };

    const handleValuesChange = (changedValues, allValues) => {
        const keys = Object.keys(changedValues);
        const hasOtherKeys = keys.some(key => key !== 'testName' && key !== 'dateRange' && key !== 'studentName');

        if (hasOtherKeys) {
            handleBadgeValuesChange();
        }

        if ('syllabusId' in changedValues || 'syllabusGroupId' in changedValues) {
            handleSearch();
        }
    }

    const handleShowRecipients = (testAssignment, classId) => {
        if(testAssignment === undefined){
            return;
        }

        setRecipientTestAssignmentId(testAssignment.testAssignmentId);
        setRecipientClassId(classId);
        setRecipientDialogOpen(true);
        setTestAssignmentName(testAssignment.testName);
        // showTestAssignmentStudents(testAssignment.testAssignmentId, classId);
    }

    useEffect(()=>{
        console.log('recipientTestAssignmentId: ',recipientTestAssignmentId);
    },[recipientTestAssignmentId])

    const handleEditTestAssignment = value => {
        setEditTestAssignmentDialogOpen(true);
        setEditTestAssignment(testAssignments.find(ta => parseInt(ta.testAssignmentId) === parseInt(value)));
    }

    useEffect(()=>{
        setTestGroupsLoading(true);
        axios.get('/web/ui/test/testGroups')
            .then(response => {
                if (response.data) {
                    setTestGroups(response.data);
                } else {
                    setTestGroups([]);
                }
            }).finally(()=>{
                setTestGroupsLoading(false);
        });
    },[]);

    useEffect(() => {
        if(classId != undefined) {
            axios.get('/web/ui/sc/studentsInClass', {params: {classId: classId}})
                .then(response => {
                    if (response.data) {
                        setStudents(response.data);
                    } else {
                        setStudents([]);
                        setStudentId(undefined);
                    }
                });
        } else {
            setStudents([]);
            setStudentId(undefined);
        }
    }, [classId]);

    const columns = [
        {
            title: <Checkbox
                aria-label={`select ${brandConfig.testName} assignments`}
                checked={testAssignments.length > 0 && selectedTestAssignments.size === testAssignments.length}
                onChange={(e) => onSelectAllRows(e.target.checked)}
            ><span className="ch-accessibility-label">select all test assignments</span></Checkbox>,
            dataIndex: 'checkbox',
            width: 50,
            render: (_, record) => (
                <Checkbox
                    aria-label={`select ${brandConfig.testName} assignment ${record.testName}`}
                    checked={selectedTestAssignments.has(record.testAssignmentId)}
                    onChange={e => onSelectRow(e.target.checked, record)}
                ><span className="ch-accessibility-label">select test assignment</span></Checkbox>
            ),
        },
        {
            title: brandConfig.testName,
            dataIndex: 'name',
            sorter: false,
            render: (_, record) => <Tooltip trigger={['hover', 'focus']}  title={'Edit '+brandConfig.testName.toLowerCase()}><a className={'ch-link'} tabIndex={0} onKeyDown={(e) => {if(e.key === 'Enter'){handleEditTestAssignment(record.testAssignmentId)}}} onClick={() => handleEditTestAssignment(record.testAssignmentId)}>{record.testName}</a> {record.note && <><br/><span className="ch-text-note">{record.note}</span></>}</Tooltip>
        },
        {
            title: 'Status',
            dataIndex: 'status',
            align:'center',
            sorter: false,
            render: (_, record) => <>{record.inProgressDescription}<br/><Tag color="green">{record.testTypeDescription}</Tag></>
        },
        {
            title: 'Assigned',
            dataIndex: 'assignedDate',
            align:'center',
            sorter: false,
            render: (_, record) => {
                if(record.assignedDate === undefined) {
                    return '';
                }

                const dateFormatted = user.dateTimeMinuteFormat.format(record.assignedDate);
                return <span>{dateFormatted}<br/>{record.assignerFirstName} {record.assignerLastName}</span>;
            }
        },
        {
            title: 'Start',
            dataIndex: 'startDate',
            align:'center',
            sorter: false,
            render: (_, record) => {
                if(record.startDate === undefined) {
                    return '';
                }

                return user.dateTimeMinuteFormat.format(record.startDate);
            }
        },
        {
            title: 'Expiry',
            dataIndex: 'endDate',
            align:'center',
            sorter: false,
            render: (_, record) => {
                if(record.endDate === undefined) {
                    return '';
                }

                return user.dateTimeMinuteFormat.format(record.endDate);
            }
        },
        {
            title: 'Recipients',
            dataIndex: 'recipients',
            sorter: false,
            render: (_, record) => {
                if(record.assignedToStudents) {
                    return <a className={'ch-link'} tabIndex={0} onKeyDown={(e) => {if(e.key === 'Enter'){handleShowRecipients(record)}}} onClick={() => handleShowRecipients(record)}>{record.studentNames ? record.studentNames : 'students'}</a>;
                } else if(record.classes !== undefined) {
                    return record.classes.map((clazz, index) => <>{index === 0 ? '' : ', '}<a className={'ch-link'} tabIndex={0} onKeyDown={(e) => {if(e.key === 'Enter'){handleShowRecipients(record)}}} onClick={() => handleShowRecipients(record, clazz.classId)}>{clazz.className}</a></>);
                }
                return '';
            }
        },
        {
            title: 'Results',
            dataIndex: 'results',
            align:'center',
            sorter: false,
            render: (_, record) => {
                return <><a className={'ch-link'} tabIndex={0} style={{whiteSpace: 'nowrap'}} onKeyDown={(e) => {if(e.key === 'Enter'){handleViewTestAssignmentResults(record.testAssignmentId)}}} onClick={() => handleViewTestAssignmentResults(record.testAssignmentId)}>Student results</a><br/><a className={'ch-link'} tabIndex={0} style={{whiteSpace: 'nowrap'}} onKeyDown={(e) => {if(e.key === 'Enter'){handleViewTestAssignmentQuestionResults(record.testAssignmentId)}}}  onClick={() => handleViewTestAssignmentQuestionResults(record.testAssignmentId)}>Question results</a>
                    <Chart
                    chartType="PieChart"
                    data={[
                        ["Students complete", 'Percent'],
                        ['Complete', record.percentStudentsComplete ],
                        ['Incomplete', 100 - record.percentStudentsComplete],
                    ]}
                    options={{
                        legend: 'none',
                        pieSliceText: 'none',
                        backgroundColor: 'transparent',
                        slices: {
                            0: { color: "#4CAF50" },
                            1: { color: "#E0E0E0" },
                        },
                        tooltip: { trigger: 'none' },
                        enableInteractivity: false,
                    }}
                    width="50px"
                    height="50px"
                    style={{marginLeft: '20px'}}
                />{record.percentStudentsComplete + '%'} students completed</>;
            }
        }
    ];

    const handleSearch = () => {
        handleBadgeValuesChange();
        setReload(new Date().getTime());
    };

    const handleViewTestAssignmentResults = (value) => {
        setTestAssignmentId(value);
        setVisibleSection('TEST_ASSIGNMENT_RESULTS');
    };

    const handleCloseTestAssignmentResults = () => {
        setTestAssignmentId(undefined);
        setTestResult(undefined);
        setVisibleSection('TEST_ASSIGNMENTS');
    };

    const handleViewTestAssignmentQuestionResults = (value) => {
        setTestAssignmentId(value);
        setVisibleSection('TEST_ASSIGNMENT_QUESTIONS_RESULTS');
    };

    const handleCloseTestAssignmentQuestionResults = () => {
        setTestAssignmentId(undefined);
        setVisibleSection('TEST_ASSIGNMENTS');
    };

    const handleViewTestResult = (value) => {
        setTestResult(value);
        setVisibleSection('TEST_RESULTS');
    };

    const handleCloseTestResult = () => {
        setTestResult(undefined);
        setVisibleSection('TEST_ASSIGNMENT_RESULTS');
    };

    // const handleTableChange = (pagination, filters, sorter) => {
    //     let orderBy = 'CREATED_DESC';
    //     if(sorter.field == 'createDate') {
    //         if(sorter.order == 'ascend') {
    //             orderBy = 'CREATED';
    //         } else {
    //             orderBy = 'CREATED_DESC';
    //         }
    //     } else if (sorter.field == 'testName') {
    //         if(sorter.order == 'ascend') {
    //             orderBy = 'NAME';
    //         } else {
    //             orderBy = 'NAME_DESC';
    //         }
    //     } else if (sorter.field == 'assignedDate') {
    //         if(sorter.order == 'ascend') {
    //             orderBy = 'ASSIGNED';
    //         } else {
    //             orderBy = 'ASSIGNED_DESC';
    //         }
    //     }
    //     setOrderBy(orderBy);
    // };

    const fetchData = (pagingParams, handleTableData, handlePagingData, abortController) => {
        const formValues = testResultSearchForm.getFieldsValue();
        const testName = formValues.testName || undefined;
        const studentName = formValues.studentName || undefined;
        const syllabusId = formValues.syllabusId || undefined;
        const [startDate, endDate] = formValues.dateRange || [];
        const clazzId = formValues.classId;

        const payload = {
            pageNumber:  pagingParams.pageNumber,
            pageSize: pagingParams.pageSize,
            testType: testType,
            testAssignerSearchType: testAssignerSearchType || undefined,
            testGroupCode: testGroupCode,
            testName: testName,
            studentName: studentName,
            classId: clazzId,
            studentId: studentId,
            syllabusId: syllabusId,
            exam: exam,
            archived: archived,
            startDate: startDate,
            endDate: endDate
        };

        axios.post('/web/ui/test/teacher/testAssignments/search', payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            signal: abortController.signal
        }).then(response => {
            const totalResults = response.data.totalResults ?? 0;
            const testsName = brandConfig.testsName.toLowerCase();

            handleTableData(response.data.currPageContents);
            setTestAssignments(response.data.currPageContents);
            clearSelectedTestAssignments();
            handlePagingData({
                pageSize: pagingParams.pageSize,
                totalResults: response.data.totalResults ?? 0,
            });

            const resultMessage = totalResults === 1 ? `1 ${brandConfig.testName.toLowerCase()}` : `${totalResults} ${testsName}`;
            setSrAnnouncement(`Table updated. ${resultMessage} found.`);
        }).catch(error => {
                console.error('Error loading data:', error);
                handleTableData([]);
        });
    };

    const handleChangeTestGroup = (value) => {
        setTestGroupCode(value);
    };

    const handleArchiveTestAssignments = () => {
        if (selectedTestAssignments == undefined || selectedTestAssignments.size == 0) {
            message.error('Please select a ' + brandConfig.testName + ' assignment to archive.');

            return;
        }

        setDisableArchive(true);
        setUpdating(true);
        axios.post('/web/ui/test/archiveTestAssignments', Array.from(selectedTestAssignments.keys()), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            displayToastMessage(brandConfig.testName + ' assignments has been archived', '', 'success');
            searchTestAssignments();
        }).catch(error => {
            console.error('Error archiving test assignments:', error);
            setDisableArchive(false);
        }).finally(() => {
            setUpdating(false);
        });
    };

    const handleUnarchiveTestAssignments = () => {
        if (selectedTestAssignments == undefined || selectedTestAssignments.size == 0) {
            message.error('Please select a ' + brandConfig.testName + ' assignment to archive.');

            return;
        }

        setDisableArchive(true);
        setUpdating(true);
        axios.post('/web/ui/test/unarchiveTestAssignments', Array.from(selectedTestAssignments.keys()), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            displayToastMessage(brandConfig.testName + ' assignments has been unarchived', '', 'success');
            searchTestAssignments();
        }).catch(error => {
            console.error('Error archiving test assignments:', error);
            setDisableArchive(false);
        }).finally(() => {
            setUpdating(false);
        });
    };

    const handleTestAssignerSearchType = (value) => {
        setTestAssignerSearchType(value);
    };


    return (
        <>
            <LiveRegion message={srAnnouncement} />
            <div className={'js-testAssignmentSearchContainer' + (visibleSection != 'TEST_ASSIGNMENTS' ? ' ch-hide' : '')} >
                <div>
                    <TableFilterControls
                        filterCount={activeFilterCount}
                        showFilterButton={true}
                        primaryFilterItem={
                            <Form.Item label={brandConfig.testsName}>
                                <Space orientation="horizontal">
                                    <Select
                                        aria-label="assessment assigner"
                                        value={testAssignerSearchType}
                                        onChange={handleTestAssignerSearchType}
                                        style={{width: 180}}
                                        getPopupContainer={trigger => trigger.parentElement}
                                        options={[{value:'TEACHER', label:'My '+ brandConfig.testsName.toLowerCase()},
                                            {value:'SCHOOL', label:'School '+brandConfig.testsName.toLowerCase()}]}
                                    />
                                </Space>
                            </Form.Item>
                        }
                        filterContent={
                            <TableFilterControlsForm
                                form={testResultSearchForm}
                                onFinish={handleSearch}
                                onValuesChange={handleValuesChange}
                                initialValues={{nameSearch: ''}}
                                useApplyButton={true}
                            >
                                <TableFilterControlsSection>
                                    <Form.Item label={`${brandConfig.testName} name`} name="testName">
                                        <Input/>
                                    </Form.Item>
                                    <Form.Item label="Class" name="classId">
                                        <ClassSelect
                                            classes={user.classes}
                                            width={'100%'}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Created date" name="dateRange">
                                        <RangePicker format={user.getDateFormatString()} style={{width: '100%'}} getPopupContainer={trigger => trigger.parentElement} />
                                    </Form.Item>
                                    <Form.Item
                                        name="contentCategory"
                                        label="Content category"
                                    >
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            showSearch={false}
                                            getPopupContainer={trigger => trigger.parentElement}
                                            onChange={(selectedValues) => {
                                                setExam(selectedValues.includes('filter-by-exam') ? true : null);
                                                setArchived(selectedValues.includes('archived-only'));
                                            }}
                                            options={[{label:'Exam Only', value:'filter-by-exam'},
                                                {label:'Archived Only', value:'archived-only'}]}
                                        />
                                    </Form.Item>
                                </TableFilterControlsSection>
                                <TableFilterControlsSection>
                                    <SyllabusTopicConceptSelect
                                        form={testResultSearchForm}
                                        selectLevel="syllabus"
                                        defaultLevel="syllabusGroup"
                                        onLoadComplete={onLoadComplete}
                                    />
                                </TableFilterControlsSection>
                                <TableFilterControlsSection showDivider={false}>
                                    <Form.Item label="Assigment type" name="testType">
                                            <Select
                                                aria-label="assignment type"
                                                value={testType}
                                                allowClear={true}
                                                placeholder="Select a assignment type"
                                                onChange={(value) => setTestType(value)}
                                                getPopupContainer={trigger => trigger.parentElement}
                                                options={[{label: 'Assessment', value: 'ASSESSMENT'},
                                                    {label: 'Revision', value: 'REVISION'},
                                                    {label: brandConfig.taskName, value: 'PATHWAY'}]}
                                            />
                                    </Form.Item>
                                    <Form.Item label="Student" name="studentId">
                                        <Select
                                            allowClear={true}
                                            placeholder="Select a student"
                                            value={studentId}
                                            onChange={(value) => setStudentId(value)}
                                            getPopupContainer={trigger => trigger.parentElement}
                                            options={students.map((student) => ({
                                                value: student.userId,
                                                label: student.firstName + " " + student.lastName,
                                            }))}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Student Name" name="studentName">
                                        <Input/>
                                    </Form.Item>
                                    {brandConfig.testGroupCodes &&
                                        <Form.Item label={brandConfig.testName + " group"} name="testGroupCode">
                                            <Select
                                                loading={isTestGroupsLoading}
                                                placeholder="Select group"
                                                allowClear={true}
                                                onChange={handleChangeTestGroup}
                                                getPopupContainer={trigger => trigger.parentElement}
                                                options={testGroups.map((item) => (
                                                    {label:item.testGroupName, value:item.testGroupCode}
                                                ))}
                                            />
                                        </Form.Item>
                                    }

                                </TableFilterControlsSection>
                            </TableFilterControlsForm>
                        }
                    />
                    <Row justify="start" className="margin-t--m margin-b--m">
                        <Space>
                            <PopConfirm title={<span>Archive {brandConfig.testName} assignments?</span>}
                                        okText='Archive'
                                        onConfirm={handleArchiveTestAssignments}>
                                <Button disabled={selectedTestAssignments.size === 0 || isDisableArchive}>Archive</Button>
                            </PopConfirm>
                            <PopConfirm title={<span>Unarchive {brandConfig.testName} assignments?</span>}
                                        okText='Unarchive'
                                        onConfirm={handleUnarchiveTestAssignments}>
                                <Button disabled={selectedTestAssignments.size === 0 || isDisableUnarchive}>Unarchive</Button>
                            </PopConfirm>
                        </Space>
                        <Space>
                            <CircularLoader visible={isUpdating} pageCentered={false} displayInElement={true}/>
                        </Space>
                    </Row>
                    <TableAntD
                        dynamicWidth={true}
                        pagingData={{ fetchFunction: fetchData, params: { pageSize: 10, currentPage: 1}}}
                        pagingDependencies={[reload, classId, exam, archived, testAssignerSearchType, testType, testGroupCode, studentId]}
                        columnData={columns}
                        rowKey="testAssignmentId"
                        // onChange={handleTableChange}
                        rowClassName="ch-align-top"
                        locale={{
                            emptyText: (
                                <span className="ch-warning-text">No {brandConfig.testName.toLowerCase()} assignments found</span>
                            )
                        }}
                    />
                    <Row justify="start" className="margin-t--m margin-b--m">
                        <Space>
                            <PopConfirm title={<span>Archive {brandConfig.testName} assignments?</span>}
                                        okText='Archive'
                                        onConfirm={handleArchiveTestAssignments}>
                                <Button disabled={selectedTestAssignments.size == 0 || isDisableArchive}>Archive</Button>
                            </PopConfirm>
                        </Space>
                        <Space>
                            <CircularLoader visible={isUpdating} pageCentered={false} displayInElement={true}/>
                        </Space>
                    </Row>
                </div>
            </div>
            <TestRecipientDialog testAssignmentId={recipientTestAssignmentId} testAssignmentName={testAssignmentName} classId={recipientClassId} open={isRecipientDialogOpen} onClose={()=>{setRecipientDialogOpen(false)}} />
            {testResult === undefined && visibleSection === 'TEST_ASSIGNMENT_RESULTS' &&
                <TestAssignmentTestResults testAssignmentId={testAssignmentId}
                                           handleBack={handleCloseTestAssignmentResults}
                                           handleViewTestResult={handleViewTestResult}/>
            }
            {testResult !== undefined  && visibleSection === 'TEST_RESULTS' &&
                <TestResult testResultId={testResult.testResultId} studentId={testResult.userId} testAssignmentId={testResult.testAssignmentId} handleBack={handleCloseTestResult}/>
            }
            {testAssignmentId !== undefined && visibleSection === 'TEST_ASSIGNMENT_QUESTIONS_RESULTS' &&
                <TestAssignmentQuestionResults testAssignmentId={testAssignmentId} handleBack={handleCloseTestAssignmentQuestionResults}/>
            }
            {editTestAssignment &&
                <EditTestAssignmentDialog open={isEditTestAssignmentDialogOpen} onClose={() => setEditTestAssignmentDialogOpen(false)} setReload={handleSearch} testAssignment={editTestAssignment} />
            }
        </>
    );
};

export default TeacherTestsAssignments;